module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020/0017.jpg?v=639a517a";